<script lang="ts">
  import DynamicBlock from '$components/blocks/dynamic-block.svelte';
  import CmsImage from '$components/cms-image.svelte';
  import CoverImage from '$components/cover-image.svelte';
  import CollectionDirectory from '$components/directory/collection-directory.svelte';
  import Seo from '$components/seo.svelte';
  import { cn } from '$lib/utils';
  import { buildPath } from '$lib/utils/paths';
  import type { ShopPage } from './content';

  export let data: ShopPage;

  const cover_image = data.story.content.cover_image;
  const mobile_image = data.story.content.mobile_image;
  const page_title = data.title || data.story.name;
  const handle = data.story.content.collection.toString();
  const shopifySEO = data.seo;
  const subcategories = data.story.content.subcategories_filters_list as string[];
  const sub_cols =
    data.story.content.sub_collections &&
    typeof data.story.content.sub_collections !== 'string' &&
    !!data.story.content.sub_collections.length
      ? data.story.content.sub_collections
      : false;
</script>

<Seo
  title={data.story.content.seo_title || shopifySEO?.title}
  description={data.story.content.seo_description || shopifySEO?.description}
  image={data.story.content.seo_og_image}
/>
<div class="[&>:last-child]:pb-2 lg:[&>:last-child]:pb-8">
  {#if cover_image?.filename}
    <CoverImage
      class={cn('mt-2 lg:mt-4 lg:block', !mobile_image?.filename ? 'block' : 'hidden')}
      image={cover_image}
      title={page_title}
    />
  {/if}

  {#if mobile_image?.filename}
    <CoverImage class="mt-2 lg:mt-4 block lg:hidden" image={mobile_image} title={page_title} />
  {/if}

  {#if sub_cols}
    <section class="px-2 pt-2 lg:px-8 lg:pt-4 pb-4">
      <div class="container mx-auto">
        <div class="-mx-2 flex gap-2 overflow-auto pr-2 hide-scrollbar lg:-mx-8 lg:gap-4 lg:pr-8">
          {#each sub_cols as collection, i}
            {#if typeof collection === 'string' || sub_cols.length === 0}
              <div />
            {:else}
              <a
                href={$buildPath({
                  path: collection.full_slug
                })}
                class={cn(
                  'group relative flex h-20 lg:h-30 min-w-[114px] flex-1 items-center justify-center rounded-sm overflow-hidden border-none text-center text-lg font-semibold text-primary/96 shadow-none outline-none transition-all focus-visible:ring lg:min-w-[114px] bg-primary/4',
                  i === 0 && 'ml-2 lg:ml-8'
                )}
              >
                <div
                  class="absolute z-10 inset-0 bg-black/14 group-hover:opacity-0 transition-opacity"
                />
                {#if collection.content.cover_image?.filename}
                  <CmsImage
                    image={collection.content.cover_image}
                    widths={[(w) => w]}
                    options={{ size: [256, 120] }}
                    sizes="25vw"
                    class="absolute z-0 inset-0 w-full h-full object-cover"
                  />
                {/if}
                <p class="z-20 text-highlight">
                  {collection.name}
                </p>
              </a>
            {/if}
          {/each}
        </div>
      </div>
    </section>
  {/if}

  {#if data.story.content.pre_body}
    {#each data.story.content.pre_body as block}
      <DynamicBlock {block} />
    {/each}
  {/if}

  <CollectionDirectory
    collectionName={page_title}
    collectionHandle={handle}
    pageSize={data.pageSize}
    {subcategories}
    marketingItems={data.story.content.marketing_items}
  />

  {#if data.story.content.body}
    {#each data.story.content.body as block}
      <DynamicBlock {block} />
    {/each}
  {/if}
</div>
